import PropTypes from 'prop-types';
import React, { lazy, useEffect } from 'react';
import { NavItem, NavLink, TabContent } from 'reactstrap';

import { useTranslation } from 'react-i18next';
import { ModalLazyContent } from '../Modal/LazyContent';
import { ModalScreenHeader, ModalScreenHeaderNav } from '../Modal/Screen/Header';
import { ModalScreen } from '../Modal/Screen/Screen';
import { useUserSettings } from './Context';
import { MembershipModalTab } from './MembershipModalTab';

const MembershipModalContent = lazy(() => import('./MembershipModalContent'));

export const MembershipModal = ({ defaultTab, isOpen }) => {
	const { t } = useTranslation();
	const { closeModal, setActiveTab, activeTab } = useUserSettings();

	useEffect(() => {
		setActiveTab(defaultTab);
	}, [defaultTab, setActiveTab]);

	return (
		<ModalScreen
			bodyClassName="py-0"
			header={(
				<ModalScreenHeader
					onClose={closeModal}
					title={t('UserSettings.MembershipModal.membership')}
				>
					<ModalScreenHeaderNav className="mt-3">
						<NavItem className="mr-3">
							<NavLink
								title={t('UserSettings.MembershipModal.membership')}
								onClick={() => setActiveTab(MembershipModalTab.MEMBERSHIP)}
								active={activeTab === MembershipModalTab.MEMBERSHIP}
							>
								<span>{t('UserSettings.MembershipModal.membership')}</span>
								<div className="divider" />
							</NavLink>
						</NavItem>
						<NavItem className="mx-3">
							<NavLink
								title={t('UserSettings.MembershipModal.pricing')}
								onClick={() => setActiveTab(MembershipModalTab.PRICING)}
								active={activeTab === MembershipModalTab.PRICING}
							>
								<span>{t('UserSettings.MembershipModal.pricing')}</span>
								<div className="divider" />
							</NavLink>
						</NavItem>
						<NavItem className="ml-3">
							<NavLink
								title={t('UserSettings.MembershipModal.billing')}
								onClick={() => setActiveTab(MembershipModalTab.BILLING)}
								active={activeTab === MembershipModalTab.BILLING}
							>
								<span>{t('UserSettings.MembershipModal.billing')}</span>
								<div className="divider" />
							</NavLink>
						</NavItem>
						<NavItem className="ml-3">
							<NavLink
								title={`PI ${t('UserSettings.MembershipModal.points')}`}
								onClick={() => setActiveTab(MembershipModalTab.POINTS)}
								active={activeTab === MembershipModalTab.POINTS}
							>
								<span>PI {t('UserSettings.MembershipModal.points')}</span>
								<div className="divider" />
							</NavLink>
						</NavItem>
						<NavItem className="ml-3">
							<NavLink
								title={t('UserSettings.MembershipModal.cashout')}
								onClick={() => setActiveTab(MembershipModalTab.CASH_OUTS)}
								active={activeTab === MembershipModalTab.CASH_OUTS}
							>
								<span>{t('UserSettings.MembershipModal.cashoutMaj')}</span>
								<div className="divider" />
							</NavLink>
						</NavItem>
					</ModalScreenHeaderNav>
				</ModalScreenHeader>
			)}
			isOpen={isOpen}
			onClose={closeModal}
		>
			<TabContent activeTab={activeTab}>
				<ModalLazyContent>
					<MembershipModalContent />
				</ModalLazyContent>
			</TabContent>
		</ModalScreen>
	);
};

MembershipModal.propTypes = {
	defaultTab: PropTypes.string,
	isOpen: PropTypes.bool.isRequired,
};

MembershipModal.defaultProps = {
	defaultTab: MembershipModalTab.MEMBERSHIP,
};
